import styled from 'styled-components';
import { Accordion as AccordionBootstrap, Tabs, Card, Col } from 'react-bootstrap';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

import { ChevronDown } from '../Icons';
import { COLORS } from '../../theme/colors';
import { disabledSectionMixin } from '../../theme/mixins';

export const FilterLabel = styled.div`
  padding-bottom: 6px;
  color: ${({ theme: { colors } }) => colors['grey-3']};
  font-size: ${({ theme: { fontSize } }) => fontSize.sm};

  @media (min-width: ${WindowBreakpoints.xxxLarge + 1}px) {
    height: 42px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
`;

export const FilterSection = styled.div`
  display: flex;
  flex-wrap: nowrap;

  @media (max-width: ${WindowBreakpoints.xxxLarge}px) {
    flex-wrap: wrap;
  }

  & > div.col-sm-4 {
    @media (min-width: ${WindowBreakpoints.xxxLarge + 1}px) {
      flex: auto;
      max-width: 200px;
    }
  }
`;

export const FilterCol = styled(Col)`
  padding: 4px 6px;
`;

export const Accordion = styled(AccordionBootstrap)`
  width: 100%;

  .nav-item {
    .nav-link {
      color: ${COLORS.GREY_21};
    }
    .nav-link: hover {
      color: ${COLORS.BLACK};
    }
  }
`;

export const AccordionToggle = styled(AccordionBootstrap.Button)`
  min-height: 25px;
  border: 1px solid ${COLORS.BLUE_11};
  border-radius: 4px;
  padding: 6px 16px;
  font-size: ${({ theme: { fontSize } }) => fontSize.normal};
  line-height: 19px;
  background-color: ${COLORS.BLUE_11} !important;
  color: ${COLORS.WHITE} !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: auto;
  white-space: nowrap;
  margin-bottom: 16px;
  padding: 4px 8px;

  &:hover:enabled {
    background-color: ${COLORS.BLUE_7} !important;
    border-color: ${COLORS.BLUE_7} !important;
  }

  &:disabled {
    background-color: ${COLORS.GREY_9} !important;
    border-color: ${COLORS.GREY_9} !important;
  }

  &:focus,
  &:active,
  &.btn-primary:not(:disabled):active {
    border-color: ${COLORS.BLUE_11} !important;
    box-shadow: none !important;
  }

  svg {
    width: 13px;
    height: 13px;
    flex-shrink: 0;
  }

  &::after {
    display: none;
    filter: brightness(0) invert(1);
    margin-left: 0px;
    transform: rotate(0deg);
    transition: transform 0.2s ease;
  }

  &:not(.collapsed)::after {
    transform: rotate(-90deg);
  }
`;

export const CardBody = styled(Card.Body)<{ $locked?: boolean }>`
  padding-top: 0;

  ${({ $locked }) => $locked && disabledSectionMixin}
`;

export const ChevronDisplayFilters = styled(ChevronDown)<{
  active?: boolean;
}>`
  margin-right: 10px;
  opacity: 1;
  transition: all 0.3s ease;
  transform: ${({ active }) => (active ? 'rotate(-90deg)' : 'rotate(0deg)')};

  @media (max-width: ${WindowBreakpoints.medium}px) {
    margin-left: 0;
  }
`;

export const AdditionalComponent = styled.div`
  padding-top: 10px;
`;

export const FilterTabs = styled(Tabs)`
  margin: 0 6px;
  border-bottom: 1px ${COLORS.WHITE_6} solid;

  @media (max-width: ${WindowBreakpoints.medium}px) {
    margin: 0;
  }

  & > .nav-item {
    color: ${COLORS.GREY_21};
  }
`;

export const Label = styled.div`
  padding-bottom: 6px;
  color: ${({ theme: { colors } }) => colors['grey-3']};
  font-size: ${({ theme: { fontSize } }) => fontSize.sm};
`;

export const HelpMessage = styled.div`
  font-size: 14px;
  color: ${COLORS.GREY_23};
`;

export const ErrorMessageUI = styled.div`
  margin: 10px 0;
  font-size: 14px;
  color: ${COLORS.RED_6};
`;

export const StockSection = styled.div`
  display: flex;
  padding: 0 6px;

  @media (min-width: ${WindowBreakpoints.small + 1}px) {
    justify-content: space-between;
  }

  @media (max-width: ${WindowBreakpoints.small}px) {
    flex-direction: column;
    .col-2 {
      justify-content: flex-start;
    }
  }

  @media (max-width: ${WindowBreakpoints.medium}px) {
    & > div {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const ToggleContainer = styled.div`
  height: 34px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FilterIcon = styled.img`
  width: 13px;
  height: 13px;
  flex-shrink: 0;
`;

export const FilterHeaderRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FilterControlsSlot = styled.div`
  margin-bottom: 16px;
`;
